import React, { useCallback, useEffect, useState } from 'react';
import api from '../api/api';
import SelfAttendance from '../components/SelfAttendance';
import { RestaurantEmployment, RestaurantShift } from '../types/restaurantPersonnel';
import RestaurantAttendanceHistory from '../components/RestaurantAttendanceHistory';
import { extractApiErrorMessage } from '../utils/apiError';
import './management/RestaurantPersonnel.css';

const SchedulePage: React.FC = () => {
  const [employee, setEmployee] = useState<RestaurantEmployment | null>(null);
  const [attendanceRefresh, setAttendanceRefresh] = useState(0);
  const [shifts, setShifts] = useState<RestaurantShift[]>([]);
  const [error, setError] = useState('');
  const load = useCallback(async (signal?: AbortSignal) => {
    try {
      const [me, plan] = await Promise.all([
        api.get<{ employment: RestaurantEmployment }>('/restaurant-personnel/me', { signal }),
        api.get<RestaurantShift[]>('/restaurant-personnel/me/shifts', { signal }),
      ]);
      if (signal?.aborted) return;
      setEmployee(me.data.employment);
      setAttendanceRefresh(value => value + 1);
      setShifts(plan.data);
      setError('');
    } catch (failure) {
      if (!signal?.aborted) {
        setEmployee(null);
        setShifts([]);
        setError(extractApiErrorMessage(failure, 'Не вдалося завантажити табель ресторану.'));
      }
    }
  }, []);
  useEffect(() => {
    const controller = new AbortController();
    void load(controller.signal);
    return () => controller.abort();
  }, [load]);

  return <main className="page-shell restaurant-personnel">
    <h1>Мій графік і табель ресторану</h1>
    <SelfAttendance onChanged={load} />
    {error && <p role="alert">{error}</p>}
    {employee && <section>
      <h2>{employee.fullName}</h2>
      <p>{employee.position} · Працевлаштування №{employee.id} · Ресторан №{employee.operatingGroupId}</p>
      <p>Зарплатні прогнози зі спільного HR не підставляються. Затверджені нарахування належать окремому зарплатному модулю.</p>
      <h3>Заплановані зміни</h3>
      {!shifts.length && <p>Графік ще не заповнено.</p>}
      {shifts.map(shift => <p key={shift.id}>
        {new Date(shift.startTime).toLocaleString('uk-UA')} — {new Date(shift.endTime).toLocaleString('uk-UA')}
        {' · '}{shift.isCompleted ? 'Виконано' : 'Заплановано'} {shift.notes}
      </p>)}
      <h3>Інтервали табелю</h3>
      <RestaurantAttendanceHistory path="/restaurant-personnel/me/attendance" refreshKey={attendanceRefresh} />
    </section>}
  </main>;
};
export default SchedulePage;
